module.exports = __webpack_public_path__ + "assets/mobile.81fa66f0.svg";